import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getCurrentUserDetails } from '../api/users.api';
import { CURRENT_USER_QUERY_KEY } from '../config/user-query-keys';
import { useAuth } from '@/shared/components/auth/AuthProvider';

/**
 * Starts loading `/users/me` as soon as Firebase auth is ready so `isAdmin` and permissions
 * are available before deep routes (e.g. investor shares admin tools) render.
 */
export function CurrentUserPrefetch() {
    const { user } = useAuth();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!user?.uid) {
            return;
        }
        void queryClient.prefetchQuery({
            queryKey: [...CURRENT_USER_QUERY_KEY, user.uid],
            queryFn: getCurrentUserDetails,
            staleTime: 5 * 60 * 1000,
        });
    }, [queryClient, user?.uid]);

    return null;
}
